import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    root: {
        height: 500,
        width: 760,
        display: 'flex',
        overflow: 'hidden',
        borderRadius: 10
    },

    sidebar: {
        width: 220,
        borderRight: `1px solid ${theme.palette.divider}`,
        background: theme.palette.background.paper,
        display: 'flex',
        flexDirection: 'column'
    },
    sidebarHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(0.75, 1.5),
        minHeight: 40
    },
    sidebarHeaderTitle: {
        fontWeight: 700,
        fontSize: 14
    },
    usersList: {
        overflowY: 'auto',
        flex: 1
    },
    userItem: {
        paddingTop: theme.spacing(0.6),
        paddingBottom: theme.spacing(0.6),
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        position: 'relative',
        borderLeft: '3px solid transparent'
    },
    userItemSelected: {
        background: theme.palette.action.selected
    },
    userItemOnline: {
        borderLeftColor: '#44b700'
    },
    userItemOffline: {
        borderLeftColor: theme.palette.grey[400]
    },
    userItemText: {
        margin: 0,
        '& .MuiListItemText-primary': {
            fontSize: 13,
            lineHeight: 1.3
        }
    },
    userItemTextUnread: {
        '& .MuiListItemText-primary': {
            fontWeight: 700
        }
    },
    userItemStatus: {
        fontSize: 11,
        opacity: 0.6,
        marginLeft: theme.spacing(0.75)
    },
    unreadPill: {
        minWidth: 22,
        height: 20,
        padding: '0 7px',
        borderRadius: 10,
        background: '#e53935',
        color: '#fff',
        fontSize: 12,
        fontWeight: 700,
        lineHeight: '20px',
        textAlign: 'center',
        marginLeft: theme.spacing(1),
        boxShadow: '0 0 0 2px #fff',
        animation: '$unreadPillPulse 1.6s ease-in-out infinite'
    },
    '@keyframes unreadPillPulse': {
        '0%, 100%': {
            boxShadow: '0 0 0 2px #fff, 0 0 0 0 rgba(229, 57, 53, 0.55)'
        },
        '50%': {
            boxShadow: '0 0 0 2px #fff, 0 0 0 6px rgba(229, 57, 53, 0)'
        }
    },
    headerUnreadHint: {
        marginLeft: theme.spacing(1),
        padding: '0 8px',
        height: 18,
        lineHeight: '18px',
        borderRadius: 9,
        background: '#e53935',
        color: '#fff',
        fontSize: 11,
        fontWeight: 700,
        whiteSpace: 'nowrap'
    },

    chat: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        background: theme.palette.background.default,
        minWidth: 0
    },
    chatHeader: {
        padding: theme.spacing(0.75, 1.5),
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        justifyContent: 'space-between',
        background: theme.palette.background.paper,
        minHeight: 40
    },
    titleAndStatus: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'baseline',
        gap: theme.spacing(1),
        minWidth: 0,
        overflow: 'hidden'
    },
    chatTitle: {
        fontWeight: 600,
        lineHeight: 1.2,
        fontSize: 14,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    status: {
        fontSize: 11,
        opacity: 0.7
    },
    chatWindowClose: {
        display: 'flex',
        alignItems: 'center'
    },

    messagesWrap: {
        flex: 1,
        overflowY: 'auto',
        padding: theme.spacing(1.5)
    },
    emptyMessages: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 0.5,
        fontSize: 13,
        padding: theme.spacing(2),
        textAlign: 'center'
    },

    bubbleRow: {
        display: 'flex',
        marginBottom: theme.spacing(0.8)
    },
    bubbleRowMe: {
        justifyContent: 'flex-end'
    },
    bubble: {
        maxWidth: '70%',
        padding: theme.spacing(0.9, 1.2),
        borderRadius: 12,
        boxShadow: '0 1px 0 rgba(0,0,0,0.05)'
    },
    bubbleOther: {
        background: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderTopLeftRadius: 4
    },
    bubbleMe: {
        background: theme.palette.grey[300],
        borderTopRightRadius: 4
    },
    bubbleText: {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        fontSize: 13
    },
    bubbleMeta: {
        marginTop: theme.spacing(0.3),
        opacity: 0.55,
        fontSize: 11
    },

    inputBar: {
        padding: theme.spacing(0.8, 1.2),
        background: theme.palette.background.paper,
        borderTop: `1px solid ${theme.palette.divider}`,
        display: 'flex',
        gap: theme.spacing(1),
        alignItems: 'center'
    },
    input: {
        flex: 1
    },

    searchPane: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0
    },
    searchField: {
        padding: theme.spacing(1.5)
    },
    searchResults: {
        flex: 1,
        overflowY: 'auto',
        padding: theme.spacing(0, 0.5, 1.5, 0.5)
    },
    searchItem: {
        paddingTop: theme.spacing(0.75),
        paddingBottom: theme.spacing(0.75),
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        borderLeft: '3px solid transparent'
    },
    searchItemIndicator: {
        borderLeftColor: theme.palette.primary.main
    },
    searchEmpty: {
        opacity: 0.55,
        textAlign: 'center',
        padding: theme.spacing(3),
        fontSize: 13
    }
}));
